// src/config/constants.js

// Credit card processing fee (Stripe charges 2.9% + $0.30)
export const CC_FEE_PERCENT = 0.029;
export const CC_FEE_FIXED = 0.30;

// User roles
export const USER_ROLES = {
  admin: 'admin',
  rep: 'rep',
  customer: 'customer'
};

// Pricing tiers - can be overridden per customer
export const DEFAULT_PRICING_TIERS = {
  standard: {
    name: 'Standard',
    discount: 0,
    minOrderValue: 0
  },
  silver: {
    name: 'Silver',
    discount: 5,
    minOrderValue: 500
  },
  gold: {
    name: 'Gold',
    discount: 10,
    minOrderValue: 1000
  },
  platinum: {
    name: 'Platinum',
    discount: 15,
    minOrderValue: 2500
  }
};

// Order methods - how customer places orders
export const ORDER_METHODS = {
  portal: { key: 'portal', label: 'Portal Access (Customer logs in)' },
  rep: { key: 'rep', label: 'Rep Places Orders' }
};

// Payment methods
export const PAYMENT_METHODS = {
  customerCC: { key: 'customerCC', label: 'Customer Credit Card' },
  customerInvoice: { key: 'customerInvoice', label: 'Customer Invoiced' },
  repCC: { key: 'repCC', label: 'Rep Credit Card' }
};

// Commission types
export const COMMISSION_TYPES = {
  percentage: { key: 'percentage', label: 'Percentage of Order' },
  perUnit: { key: 'perUnit', label: 'Flat Rate Per Unit' }
};

// Order statuses
export const ORDER_STATUSES = [
  'New',
  'Processing',
  'Filled',
  'Shipped',
  'Delivered',
  'Cancelled'
];

// Calculate total with CC fee
export function calculateTotalWithFee(subtotal, includesFee = true) {
  if (!includesFee) return subtotal;
  const total = (subtotal + CC_FEE_FIXED) / (1 - CC_FEE_PERCENT);
  return Math.round(total * 100) / 100;
}

// Calculate just the CC fee amount
export function calculateCCFee(subtotal) {
  const totalWithFee = calculateTotalWithFee(subtotal);
  return Math.round((totalWithFee - subtotal) * 100) / 100;
}

// Apply tier discount to a price
export function applyTierDiscount(price, tierDiscount) {
  return price * (1 - tierDiscount / 100);
}

// Calculate commission for an order
export function calculateCommission(order, rep) {
  if (!rep || !rep.commissionType || !rep.commissionRate) return 0;
  
  if (rep.commissionType === 'percentage') {
    return Math.round((order.subtotal * rep.commissionRate / 100) * 100) / 100;
  } else if (rep.commissionType === 'perUnit') {
    const totalUnits = order.items.reduce((sum, item) => sum + item.quantity, 0);
    return Math.round((totalUnits * rep.commissionRate) * 100) / 100;
  }
  return 0;
}
